import styled, { css } from "styled-components";
import { hex2rgba } from "../../utils/styles";

export const StyledStatusCircle = styled.div`
    position: relative;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.white};
    :after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -8px;
        margin-left: -8px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
    }
    ${({ variant }) => variant === 'absolute' && css`
        position: absolute;
        left: -10px;
        width: 20px;
        height: 20px;
        box-shadow: 0px 0px 2px 0px ${({ theme }) => hex2rgba(theme.colors.black, 0.16)};
        :before {
            content: '';
            position: absolute;
            top: -2px;
            left: 50%;
            width: 20px;
            height: 24px;
            background-color: ${({ theme }) => theme.colors.white};
        }
    `};
    ${({ theme, value }) => value < 50 && css`
        :after {
            background-color: ${theme.colors.red};
        }
    `};
    ${({ theme, value }) => value >= 50 && value < 100 && css`
        :after {
            background-color: ${theme.colors.darkOrange};
        }
    `};
    ${({ theme, value }) => value >= 100 && css`
        :after {
            background-color: ${theme.colors.green};
        }
    `};
    ${({ size }) => size === "small" && css`
        width: 10px;
        height: 10px;
        :after {
            margin-top: -5px;
            margin-left: -5px;
            width: 10px;
            height: 10px;
        }
    `};
    ${({ customStyle }) => customStyle && customStyle};
`;